import {
    Backdrop,
    Button,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    makeStyles,
    Typography,
} from "@material-ui/core";
import { Dialog } from "@mui/material";
import { Box } from "@mui/system";
import Config from "Config";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import sysend from "sysend";
import iamsmartTap from "../../images/iamsmart-tap.png";
import iamSmartPhone from "../../images/icon-dark.png";
import { initIamsmartIasToken } from "../../redux/action";
import {
    getFormId,
    getFormTitleParamList,
    getProfile,
} from "../../redux/selector";
import { send, sendV20 } from "../../SendRequest";
import {
    getFormTitleParam,
    getIamsmartAppUrl,
    getUserAgent,
    isEmpty,
    isIOS,
    isNotEmpty,
    isObjectEmpty,
    isObjectNotEmpty,
    mapToStringIamsmart,
} from "../../Utils";
const iamSmartBtnStyle = makeStyles((theme) => ({
    root: {
        borderRadius: 6,
        backgroundColor: theme.palette.iamSmart.main,
        color: theme.palette.common.white,
        textTransform: "none",
        "&:hover": {
            backgroundColor: theme.palette.iamSmart.main,
        },
        height: "3rem",
        fontSize: "1.11em", // 37% of height, min 12px
        "@media (max-width: 500px)": {
            height: "auto !important",
            fontSize: "1.3em", // 37% of height, min 12px
        },
    },
}));

export default function IamsmartAnonAsLoginedSigningButton({
    onSign,
    hkic,
    handleSubmit,
}) {
    const profile = useSelector(getProfile());
    const [asHkid, setAsHkid] = useState("");
    console.log(
        "IamsmartAnonSigningButtonB asHkid=====++++++++++++++++++++++",
        hkic
    );
    const formId = useSelector(getFormId());
    const formParams = useSelector(getFormTitleParamList());
    const { t, i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const [disconnectSign, setDisconnectSign] = useState(false);
    const [failSign, setFailSign] = useState(false);
    const [timeOutSign, setTimeOutSign] = useState(false);
    const [qrLinkURL, setQrLinkURL] = useState("");
    const dispatch = useDispatch();
    const handleClose = () => {
        if (isNotEmpty(requestInterval)) {
            clearInterval(requestInterval);
        }
        setOpen(false);
    };

    const handleDisconnectSignClose = () => {
        setDisconnectSign(false);
    };
    const handleFailSignClose = () => {
        setFailSign(false);
    };
    const handleTimeOutSignClose = () => {
        setTimeOutSign(false);
    };

    const [noSigning, setNoSigning] = useState(false);

    const [passcode, setPasscode] = useState("0000");
    const [businessID, setBusinessID] = useState("");
    console.log(
        "IamsmartAnonSigningButtonB businessID=====1111111",
        businessID
    );
    const [ticketID, setTicketID] = useState("");
    const [authByQR, setAuthByQR] = useState(true);
    const iamSmartBtnClasses = iamSmartBtnStyle();

    const [requestInterval, setRequestInterval] = useState();

    let iasTokenMap = sessionStorage?.getItem("iasTokenMap")
        ? JSON.parse(sessionStorage?.getItem("iasTokenMap"))
        : {};
    console.log(
        "IamsmartLoginedSigningButtonB iasTokenMap=====*****",
        JSON.stringify(iasTokenMap)
    );
    let openID = iasTokenMap?.openID;
    let accessToken = iasTokenMap?.accessToken;

    let winRef;
    const getLonginFromIamsmart = () => {
        if (isObjectEmpty(iasTokenMap)) {
            setOpen(true);
            const userAgent = navigator.userAgent;
            const headersV20 = {
                userAgent: userAgent,
                lang: t("common.iamsmart.lang"),
                redirectURI: `https://${Config.DOMAIN}${Config.CONTENT_PATH}/iamsmartAnonSigning`,
            };
            const optionV20 = {
                url: "/iamsmartedbv2/edbeform/auth/prepare-init",
                method: "POST",
                header: headersV20,
                option: { redirect: "follow" },
            };
            winRef = window.open("", "_blank");
            var QRLink = dispatch(sendV20("GET_IAMSMART_PROFILE_QR", optionV20))
                .then((response) => response.text())
                .then((result) => {
                    let strData = jwtDecode(result)?.data?.action;
                    setQrLinkURL(strData);
                    // setTimeout(function () {
                    //     winRef.location = strData;
                    // }, 100);
                    winRef.location = strData;
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                });
        }
    };
    const getcombineCallResult = (query) => {
        const paramMap = {
            idNumber: { iasName: "idNo" },
        };
        if (isEmpty(query.get("code"))) {
            handleClose();
            return;
        }
        const authCode = query.get("code");
        const isDirectLoginV2 = false;
        const optionV20 = {
            url: "/iamsmartedbv2/edbeform/profile/combineCall",
            method: "POST",
            option: { redirect: "follow" },
            header: {
                code: authCode,
                isDirectLoginV2: isDirectLoginV2,
                profileFields: [],
                eMEFields: mapToStringIamsmart(paramMap)?.split(","),
            },
        };
        dispatch(sendV20("GET_ANON_COMBINE_CALL_RESULT", optionV20))
            .then((response) => response.json())
            .then((result) => {
                console.log(
                    " IamsmartAnonSigningButtonBgetcombineCallResult response: ",
                    result
                );
                let strDataOrign = jwtDecode(result);
                let asHkidOrign = strDataOrign?.profile?.idNo?.Identification;

                console.log(
                    "IamsmartAnonSigningButtonB getcombineCallResult strData=====",
                    strDataOrign
                );
                let iasToken = strDataOrign?.iasToken;
                console.log(
                    "IamsmartAnonSigningButtonB getcombineCallResult iasToken=====",
                    JSON.stringify(iasToken)
                );
                dispatch(initIamsmartIasToken(iasToken));
                const interfaceUsername = profile?.interfaceUsername;
                console.log(
                    "interfaceUsername======********$$$$$$$$$$" +
                        interfaceUsername
                );
                if (sessionStorage && sessionStorage.setItem) {
                    sessionStorage.setItem(
                        "interfaceUsername",
                        JSON.stringify({ interfaceUsername: interfaceUsername })
                    );
                }
                openID = iasToken?.openID;
                accessToken = iasToken?.accessToken;
                setAsHkid(asHkidOrign);
            });
    };

    const getFromIamsmart = () => {
        console.log("getFromIamsmart asHkid=====", hkic);
        setOpen(true);
        const headersV20 = {
            accessToken,
            openID,
            source: navigator.userAgent,
            department: "EDB",
            serviceName: "eFormSS",
            documentName:
                `${formId} - ` +
                t(
                    `form.${formId}`,
                    getFormTitleParam(formId, formParams, i18n.language)
                ),
            hkid: hkic,
        };

        var optionV20 = {
            url: "/iamsmartedbv2/edbeform/signing/init",
            method: "POST",
            header: headersV20,
        };
        console.log("headersV20=======", JSON.stringify(headersV20));
        if (isNotEmpty(hkic)) {
            var QRLink = dispatch(sendV20("GET_SIGNING", optionV20))
                .then((response) => response.json())
                .then((result) => {
                    const strData = jwtDecode(result)?.data;
                    console.log(
                        "strData=======**********************************************************************",
                        JSON.stringify(strData)
                    );
                    if (
                        isNotEmpty(strData?.code) &&
                        strData?.code === "D70004"
                    ) {
                        setNoSigning(true);
                    }
                    setBusinessID(strData?.businessID);
                    setPasscode(strData?.signCode);
                    setTicketID(strData.ticketID);
                    setAuthByQR(strData.authByQR);
                    let printLogsParams = {
                        logId: 15,
                        msg: "GET_SIGNING_success",
                        hkic: hkic,
                    };
                    let option = {
                        url: `${
                            Config.CONTENT_PATH
                        }/${formId.toLowerCase()}/printLogs`,
                        method: "POST",
                        body: JSON.stringify(printLogsParams),
                    };
                    dispatch(send("PRINT_LOGS", option)).then((response) => {});
                })
                .catch((error) => {
                    console.log("fetch error: ", error);
                    let printLogsParams = {
                        logId: 16,
                        msg: "GET_SIGNING_error",
                        hkic: hkic,
                    };
                    let option = {
                        url: `${
                            Config.CONTENT_PATH
                        }/${formId.toLowerCase()}/printLogs`,
                        method: "POST",
                        body: JSON.stringify(printLogsParams),
                    };
                    dispatch(send("PRINT_LOGS", option)).then((response) => {});
                });
        }
    };

    const openApp = () => {
        const url = getIamsmartAppUrl(ticketID, "hash-sign");
        if (navigator.userAgent.includes("iAM Smart In-App Browser")) {
            window.location.href = url;
        } else {
            window.open(url);
        }
    };

    const getSigningResult = (businessID) => {
        console.log("start interval");
        var enResponse = true;
        const interval = setInterval(() => {
            const params = {
                url: "/iamsmartedbv2/edbeform/signing/response",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    businessID,
                }),
            };
            if (enResponse) {
                enResponse = false;
                fetch(params?.url, params)
                    .then((response) => response.json())
                    .then((data) => {
                        enResponse = true;
                        const strData = jwtDecode(data)?.data?.content;
                        const strResponeData = jwtDecode(data)?.data;
                        console.log("strResponeData=======", strResponeData);
                        const responseCode = strResponeData?.code;
                        console.log(
                            "strResponeData code=======",
                            strResponeData?.code
                        );
                        if (
                            isObjectNotEmpty(responseCode) &&
                            responseCode === "D70001"
                        ) {
                            console.log(
                                "in D70001 logic : Signing cancelled, please try again"
                            );
                            handleClose();
                            clearInterval(interval);
                            setDisconnectSign(true);
                            return;
                        } else if (responseCode === "D70002") {
                            console.log(
                                "in D70002 logic : Signing failed, please try again"
                            );
                            handleClose();
                            clearInterval(interval);
                            setFailSign(true);
                            return;
                        } else if (responseCode === "D70003") {
                            console.log(
                                "in D70002 logic : Signing failed, please try again"
                            );
                            handleClose();
                            clearInterval(interval);
                            setTimeOutSign(true);
                            return;
                        }
                        if (
                            isObjectNotEmpty(strData?.businessID) &&
                            isObjectNotEmpty(strData?.signature)
                        ) {
                            clearInterval(interval);
                            console.log(
                                "getAnonSigningResult response: ",
                                strData
                            );
                            setPasscode("0000");
                            handleClose();
                            onSign(
                                strData?.signature,
                                strData?.cert,
                                strData?.hashCode,
                                strData?.timestamp
                            );
                            let printLogsParams = {
                                logId: 7,
                                msg: "getSigningResult_success",
                                hkic: hkic,
                            };
                            let option = {
                                url: `${
                                    Config.CONTENT_PATH
                                }/${formId.toLowerCase()}/printLogs`,
                                method: "POST",
                                body: JSON.stringify(printLogsParams),
                            };
                            dispatch(send("PRINT_LOGS", option)).then(
                                (response) => {}
                            );
                        }
                    })
                    .catch((error) => {
                        console.log("fetch error: ", error);
                        let printLogsParams = {
                            logId: 6,
                            msg: "getSigningResult_error",
                            hkic: hkic,
                        };
                        let option = {
                            url: `${
                                Config.CONTENT_PATH
                            }/${formId.toLowerCase()}/printLogs`,
                            method: "POST",
                            body: JSON.stringify(printLogsParams),
                        };
                        dispatch(send("PRINT_LOGS", option)).then(
                            (response) => {}
                        );
                    });
            }
        }, 2000);
        setRequestInterval(interval);
    };

    useEffect(() => {
        hkic = asHkid;
        getFromIamsmart();
    }, [asHkid]);

    useEffect(() => {
        console.log(
            "IamsmartAnonSigningButtonB businessID=====2222",
            businessID
        );
        if (isNotEmpty(businessID)) {
            console.log(
                "IamsmartAnonSigningButtonB businessID=====33333",
                businessID
            );
            getSigningResult(businessID);
        }
    }, [businessID]);

    const channel = "IamsmartAnonSigning";
    let channelForIos;
    useEffect(() => {
        if (isNotEmpty(qrLinkURL) && isEmpty(openID)) {
            //window.open(qrLinkURL, "iamsmart");
            if (!isIOS()) {
                console.log("add non ios listener");
                console.log("sysend is listening...");
                sysend.on(channel, (data) => {
                    console.log("recieved data from other tab: ", data);
                    const query = new URLSearchParams(data);
                    getcombineCallResult(query);
                });
            }
            if (isIOS()) {
                channelForIos = new BroadcastChannel("web_channel");
                channelForIos.onmessage = (e) => {
                    const rnQuery = new URLSearchParams(e.data.query);
                    getcombineCallResult(rnQuery);
                };
            }
            return () => {
                if (isIOS()) {
                    channelForIos.close();
                }
                if (!isIOS()) sysend.off(channel);
            };
        }
    }, [qrLinkURL]);

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "90%",
        height: "90%",
        bgcolor: "white",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };
    return (
        <Box>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={disconnectSign}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t("common.iamsmart.disconnectSign")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDisconnectSignClose}>
                        {t("common.iamsmart.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={failSign}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t("common.iamsmart.failSign")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleFailSignClose}>
                        {t("common.iamsmart.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={timeOutSign}
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t("common.iamsmart.failSign")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleTimeOutSignClose}>
                        {t("common.iamsmart.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
            <Button
                variant="contained"
                classes={{ root: iamSmartBtnClasses.root }}
                startIcon={
                    <img
                        className="iamSmartPhone"
                        src={iamSmartPhone}
                        alt=""
                        width="20px"
                    />
                }
                className="iamSmartButton"
                onClick={() => {
                    try {
                        if (isObjectEmpty(openID)) {
                            handleSubmit(getLonginFromIamsmart)();
                        } else {
                            handleSubmit(getFromIamsmart)();
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }}
            >
                <div
                    style={
                        i18n.language === "en"
                            ? { width: "15rem", minWidth: "15rem" }
                            : {}
                    }
                >
                    {t("common.button.iamSmartSigning")}
                </div>
            </Button>
            <Box style={{ textAlign: "center" }}>
                <a
                    href={"https://www.iamsmart.gov.hk/" + i18n.language}
                    target="_blank"
                    rel="noreferrer"
                >
                    {t("common.iamsmart.moreInfo")}
                </a>
            </Box>
            {businessID !== "" && (
                <Dialog
                    disableEnforceFocus
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    BackdropComponent={Backdrop}
                    style={{ borderColor: "#e8e3cd" }}
                >
                    <DialogTitle style={{ backgroundColor: "#e8e3cd" }}>
                        {t("common.iamsmart.anonSigning.title")}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <Typography>
                                {t("common.iamsmart.anonSigning.service")}:{" "}
                                <b>eFormSS</b>
                            </Typography>
                            <Typography>
                                {t("common.iamsmart.anonSigning.document")}:{" "}
                                <b>
                                    {formId} -{" "}
                                    {t(
                                        `form.${formId}`,
                                        getFormTitleParam(
                                            formId,
                                            formParams,
                                            i18n.language
                                        )
                                    )}
                                </b>
                            </Typography>
                            <Typography style={{ display: "flex" }}>
                                {t("common.iamsmart.anonSigning.code")}:{" "}
                                {passcode != "0000" && (
                                    <Typography
                                        style={{
                                            color: "#2B7366",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        {passcode}
                                    </Typography>
                                )}
                            </Typography>
                        </DialogContentText>
                        <DialogContentText>
                            {t("common.iamsmart.signing.instruction")}
                        </DialogContentText>
                        {!noSigning && (
                            <DialogContentText>
                                {getUserAgent() === "" ? (
                                    <ol>
                                        {t("common.iamsmart.signing.step", {
                                            returnObjects: true,
                                        }).map((criteria, index) => {
                                            if (index === 0) {
                                                return (
                                                    <>
                                                        <Typography
                                                            style={{
                                                                color: "#2B7366",
                                                            }}
                                                        >
                                                            <li key={index}>
                                                                {criteria}
                                                            </li>
                                                        </Typography>
                                                        {authByQR && (
                                                            <img
                                                                src={
                                                                    iamsmartTap
                                                                }
                                                                alt={
                                                                    "i am smart icon"
                                                                }
                                                                style={{
                                                                    width: "100px",
                                                                }}
                                                            />
                                                        )}
                                                    </>
                                                );
                                            }
                                            return (
                                                <li key={index}>{criteria}</li>
                                            );
                                        })}
                                    </ol>
                                ) : (
                                    <ol>
                                        {t("common.iamsmart.sameSigning.step", {
                                            returnObjects: true,
                                        }).map((criteria, index) => {
                                            if (index === 0) {
                                                return (
                                                    <>
                                                        <li key={index}>
                                                            <Typography
                                                                style={{
                                                                    color: "#2B7366",
                                                                }}
                                                            >
                                                                {criteria}
                                                            </Typography>
                                                        </li>
                                                        {authByQR && (
                                                            <img
                                                                src={
                                                                    iamsmartTap
                                                                }
                                                                alt={
                                                                    "i am smart icon"
                                                                }
                                                                style={{
                                                                    width: "100px",
                                                                }}
                                                            />
                                                        )}
                                                    </>
                                                );
                                            }
                                            return (
                                                <li key={index}>{criteria}</li>
                                            );
                                        })}
                                    </ol>
                                )}
                            </DialogContentText>
                        )}
                        <DialogActions>
                            {!noSigning && !authByQR && (
                                <Button
                                    variant="contained"
                                    classes={{ root: iamSmartBtnClasses.root }}
                                    startIcon={
                                        <img
                                            className="iamSmartPhone"
                                            src={iamSmartPhone}
                                            alt=""
                                            width="20px"
                                        />
                                    }
                                    className="iamSmartButton"
                                    onClick={openApp}
                                    //onClick={openSignLink}
                                >
                                    <div>
                                        {t("common.iamsmart.openIamSmartSign")}
                                    </div>
                                </Button>
                            )}
                            {noSigning && (
                                <Typography>
                                    {
                                        <span
                                            className="tooltips"
                                            dangerouslySetInnerHTML={{
                                                __html: t(
                                                    "common.iamsmart.noSigning"
                                                ),
                                            }}
                                        ></span>
                                    }
                                </Typography>
                            )}
                        </DialogActions>
                    </DialogContent>
                </Dialog>
            )}
        </Box>
    );
}
